import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';

export const ContainerBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
}))((props: BoxProps) => <Box {...props} />);

export default ContainerBox;
